import React from "react";

class ContactForm extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.contactForm = null;
        this.success = null;
        this.title = null;
        this.name = null;
        this.surname = null;
        this.email = null;
        this.phone = null;
        this.text = null;

        this.validateEmail = this.validateEmail.bind(this);


    }

    validateEmail(email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    handleSubmit(event) {
        event.preventDefault();




        if (this.name.value == '') {
            alert('Zadajte meno!');
            return;
        }
        if (this.surname.value == '') {
            alert('Zadajte priezvisko!');
            return;
        }
        if (!this.validateEmail(this.email.value)) {
            alert('Neplatný formát e-mailu!');
            return;
        }

        if (this.text.value == '') {
            alert('Vyplňte správu!');
            return;
        }

        const data = new FormData(event.target);

        fetch('/ajax/send-contact-form.php', {
            'method': 'POST',
            body: data
        }).then(result => {
            return result.json();
        }).then(data => {
            let msg = data.msg;
            let code = data.code;
            if (code == 1) {

                this.contactForm.reset();

                this.contactForm.classList.add('fadeOut');
                setTimeout(() => {
                    this.success.style.display = 'block';
                    this.success.classList.remove('fadeOut');
                    this.success.classList.add('fadeIn');
                }, 400);

                setTimeout(() => {
                    this.contactForm.classList.remove('fadeOut');
                    this.contactForm.classList.add('fadeIn');
                    this.success.classList.remove('fadeIn');
                    this.success.classList.add('fadeOut');
                }, 2000);

                setTimeout(() => {
                    this.success.style.display = 'none';
                }, 2800);


            } else {
                alert(msg);
            }
        })
    }

    render() {
        const {lang} = this.props;
        return (

            <section data-animation-ref="" className="form">
                <div className="container">
                    <form className="animated" action="" method="post" onSubmit={this.handleSubmit} ref={ref => (this.contactForm = ref)}>
                        <div className="row">
                            <div className="col-lg-1 col-md-2 col-sm-2 form-group">
                                <label htmlFor="title" className="form-label">{lang.TITLE}</label>
                                <input id="title" ref={ref => (this.title = ref)} name="title" type="text" className="form-control" />
                                    <span className="focus-border"></span>
                            </div>
                            <div className="col-lg-5 col-md-4 col-sm-4 form-group">
                                <label htmlFor="name" className="form-label">{lang.NAME} <span>*</span></label>
                                <input type="text" id="name" ref={ref => (this.name = ref)} name="name" className="form-control" />
                                    <span className="focus-border"></span>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 form-group">
                                <label htmlFor="surname" className="form-label">{lang.SURNAME} <span>*</span></label>
                                <input type="text" id="surname" ref={ref => (this.surname = ref)} name="surname" className="form-control" />
                                    <span className="focus-border"></span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6 form-group">
                                <label htmlFor="email" className="form-label">{lang.EMAIL} <span>*</span></label>
                                <input type="text" id="email" ref={ref => (this.email = ref)} name="email" className="form-control" />
                                    <span className="focus-border"></span>
                            </div>

                            <div className="col-sm-6 form-group">
                                <label htmlFor="phone" className="form-label">{lang.PHONE}</label>
                                <input type="text" id="phone" ref={ref => (this.phone = ref)} name="phone" className="form-control" />
                                    <span className="focus-border"></span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group col-sm-12">
                                <label htmlFor="text" className="form-label">{lang.TEXTAREA} <span>*</span></label>
                                <textarea id="text" ref={ref => (this.text = ref)} name="text" className="form-control"></textarea>
                                <span className="focus-border"></span>
                            </div>
                        </div>
                        <p>
                            {lang.FORM_TEXT_1} <a href="">{lang.FORM_TEXT_2}</a>, {lang.FORM_TEXT_3} <a href="mailto:brainy@brainy.sk">brainy@brainy.sk</a>
                        </p>
                        <div className="wrap">
                            <button className="btn" type="submit">{lang.FORM_BUTTON}</button>
                        </div>
                    </form>

                    <p className="message-success animated" ref={ref => (this.success = ref)}>Ďakujeme za vašu správu, budeme vás kontaktovať.</p>
                </div>
            </section>

        );
    }
}

module.exports = ContactForm;
